import { Col } from "antd";
import React from "react";
import ChatsList from "@components/Chats/ChatsList";

const ChatLeft = () => {
  return (
    <>
      <Col
        xs={24}
        sm={24}
        md={6}
        lg={6}
        xl={5}
        style={{
          background: "#ffffff",
          height: "100vh",
          boxShadow: "0px 0px 15px -12px rgba(0,0,0,0.75)",
        }}
      >
        <ChatsList
        // Chatbot
        //   selectedBotId={selectedBotId}
        //   isBotSelected={isBotSelected}
        //   selectedBotName={selectedBotName}
        //   handleSelectChatbot={handleSelectChatbot}
        //   handleBackToChatbotsList={handleBackToChatbotsList}
        //   // Chat
        //   selectedChat={selectedChat}
        //   handleSelectChat={handleSelectChat}
        //   handleSelectTicketChat={handleSelectTicketChat}
        //   hasChatEnded={hasChatEnded}
        //   // Loading
        //   loading={loading}
        //   botNamesLoading={botNamesLoading}
        //   loadMoreChatsLoading={loadMoreChatsLoading}
        //   agentFetchLoading={agentFetchLoading}
        //   loadMoreHandledTicketsLoading={loadMoreHandledTicketsLoading}
        //   loadMoreUnHandledTicketsLoading={loadMoreUnHandledTicketsLoading}
        //   // Load More
        //   handleLoadMoreChats={handleLoadMoreChats}
        //   handleLoadMoreHandledTickets={handleLoadMoreHandledTickets}
        //   handleLoadMoreUnHandledTickets={handleLoadMoreUnHandledTickets}
        //   // Tabs
        //   activeListTab={activeListTab}
        //   handleChatsListTabChange={handleChatsListTabChange}
        //   activeTicketsTab={activeTicketsTab}
        //   handleTicketsTabChange={handleTicketsTabChange}
        />
      </Col>
    </>
  );
};

export default ChatLeft;
